export default class PickProgress {

    constructor() {
        this.totalItemsCount = 10;
        this.completedItemsCount = 10;
        this.pickedItemsCount = 10;
        this.damagedItemsCount = 10;
        this.missedItemsCount = 10;
        this.totalCartsCount = 10;
        this.completedCartsCount = 10;
        this.stagedCartsCount = 10;
        this.missingCartsCount = 10;
        this.durationInSecs = 10;
    }
}


// WEBPACK FOOTER //
// ./src/models/pick-progress.js